import { Injectable } from '@angular/core';
import { ProfileItem } from 'qp-ui-interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageKeys } from '../../LocalStorageKeys';
import { isLoggedIn } from '../../utils/LoginUtils';
import { getSelectedProfileFromStorage } from '../../utils/profileUtils';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserStateService {
  private _loading = false;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  private selectedProfileSubject = new BehaviorSubject<ProfileItem>(getSelectedProfileFromStorage(this.localStorage));
  private personalizationSubject = new BehaviorSubject<void>(undefined);
  private stopLoadingTimeout: ReturnType<typeof setTimeout>;
  constructor(private localStorage: LocalStorageService) {}

  get selectedProfile(): Observable<ProfileItem> {
    return this.selectedProfileSubject.asObservable();
  }

  get loading(): Observable<boolean> {
    return this.isLoadingSubject.asObservable();
  }

  get personalization(): Observable<void> {
    return this.personalizationSubject.asObservable();
  }

  get isLoading() {
    return this._loading;
  }

  updateSelectedProfile(profile: ProfileItem) {
    if (profile !== undefined) {
      this.localStorage.setItem(LocalStorageKeys.SELECTED_PROFILE, JSON.stringify(profile));
      this.localStorage.setItem(LocalStorageKeys.SELECTED_PROFILE_ID, profile.id);
    } else {
      this.localStorage.removeItem(LocalStorageKeys.SELECTED_PROFILE);
      this.localStorage.removeItem(LocalStorageKeys.SELECTED_PROFILE_ID);
    }
    this.selectedProfileSubject.next(profile);
  }

  stopLoading() {
    this._loading = false;
    this.isLoadingSubject.next(false);
  }

  startLoading() {
    this._loading = true;
    this.isLoadingSubject.next(true);
  }

  reloadPersonalization() {
    this.personalizationSubject.next();
  }

  hideSplashScreen(stopLoading = true): void {
    // if (this.localStorage.getItem(LocalStorageKeys.SPLASH_ENDED) === 'true') {
    //   const video = document.getElementById('splashVideo');
    //   const screen = document.getElementById('splashScreen');
    //   if (screen) screen.style.display = 'none';
    //   if (video) {
    //     video.style.display = 'none';
    //     if (screen && screen.parentNode) {
    //       screen.parentNode.removeChild(screen);
    //     }
    //   }
    if (stopLoading && isLoggedIn(this.localStorage) && this.isLoading) {
      if (this.stopLoadingTimeout) clearTimeout(this.stopLoadingTimeout);
      this.stopLoadingTimeout = setTimeout(() => {
        this.stopLoading();
      }, 3000);
    }
    // } else {
    //   this.localStorage.setItem(LocalStorageKeys.SPLASH_CLOSE_AT_THE_END, 'true');
    // }
  }
}
